// removed by extract-text-webpack-plugin
module.exports = {"alertWrap":"qempo_NewOrder_alertWrap-2yDSp3V","blackFridayWrap":"qempo_NewOrder_blackFridayWrap-134xbnX"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/components/NewOrder.scss
// module id = 1739
// module chunks = 0